import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Paper, TableCell } from '@mui/material';
import { TableHeadCell } from '../../components/styledComponent/table/TableCell';
import { endpoints } from '../../api/endpoints';
import { useState } from 'react';
import { EllipsisText } from '../../components/styledComponent/typography/EllipsisText';
import { TableRowsLoader } from '../../components/styledComponent/table/TableLoader';
import { Actions } from '../../components/table/TableActions';
import { DeleteAlertModal } from '../../components/modal/DeleteAlertModal';
import { TablePagination } from '../../components/pagination/Pagination';

export default function BranchListTable({ isSuperAdmin, refetchData, loading, count, setSkip, setTake, take, skip, setIsView, setSelectedItem, setOpen, rows, setBranchList }: { isSuperAdmin: boolean, refetchData: any, loading: any, take: any, skip: any, setSkip: any, setTake: any, count: any, setIsView: any, setOpen: any, setSelectedItem: any, rows: any, setBranchList: React.Dispatch<any> }) {

  const [openAlertModal, setOpenAlertModal] = useState(false);
  const [selectedId, setSelectedID] = useState<any | null>();

  const onSuccess = () => {
    setOpenAlertModal(false)
    setSelectedID(null)
    refetchData()
  }

  const onError = () => {
    setOpenAlertModal(false)
    setSelectedID(null)
  }

  const deleteAction = (row: any) => {
    if (isSuperAdmin) {
      setSelectedID(row.id);
      setOpenAlertModal(true)
    }
  }

  const editAction = (row: any, isView?: boolean) => {
    setIsView(isView ? true : false)
    setSelectedItem(row)
    setOpen(true)
  }


  return (
    <>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer sx={{ maxHeight: 460 }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableHeadCell minwidth='4%'>S.N</TableHeadCell>
                <TableHeadCell align="left" minwidth='8%'>
                  Code
                </TableHeadCell>
                <TableHeadCell align="left" minwidth='20%'>
                  Name
                </TableHeadCell>
                <TableHeadCell align="left" minwidth='23%'>
                  Address
                </TableHeadCell>
                <TableHeadCell align="left" minwidth='28%'>
                  Description
                </TableHeadCell>
                <TableHeadCell align="left" minwidth='12%'>
                  Main Branch
                </TableHeadCell>
                <TableHeadCell align="center" minwidth='5%'>
                  Actions
                </TableHeadCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!rows || loading ? <TableRowsLoader rowsNum={5} />
                : rows.length <= 0 ? <TableRow><TableCell align="center" colSpan={7}>No data found</TableCell></TableRow>
                  : rows.map((row: any, index: number) => (
                    <TableRow
                      key={row.id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell style={{ padding: "8px 4px", fontSize: "12px" }}>{skip > 0 ? skip * take + index + 1 : ++index}</TableCell>
                      <TableCell align="left" style={{ padding: "8px 4px", fontSize: "12px" }}>{row.code}</TableCell>
                      <TableCell align="left" style={{ padding: "8px 4px", fontSize: "12px" }}>{row.name}</TableCell>
                      <TableCell align="left" style={{ padding: "8px 4px", fontSize: "12px" }}>{row.address}</TableCell>
                      <TableCell align="left" style={{ padding: "8px 4px", fontSize: "12px" }}>
                        <EllipsisText clamp={2} style={{ padding: "8px 4px", fontSize: "12px" }}>{row.description}</EllipsisText>
                      </TableCell>
                      <TableCell align="center" style={{ padding: "8px 4px", fontSize: "12px" }}>{row.isMainBranch ? "Yes" : "No"}</TableCell>
                      <TableCell align="center" style={{ padding: "8px 4px" }}>
                        <Actions onDelete={deleteAction} onEdit={editAction} row={row} />
                      </TableCell>
                    </TableRow>
                  ))}
            </TableBody>
          </Table>
        </TableContainer>
        {rows && (rows?.length > 0 || !loading) ? <TablePagination count={count} skip={skip} setSkip={setSkip} take={take} setTake={setTake} /> : null}
      </Paper>
      < DeleteAlertModal
        onSuccess={onSuccess}
        onError={onError}
        endpoint={endpoints.branch.delete}
        selectedId={selectedId}
        openAlertModal={openAlertModal}
        setOpenAlertModal={setOpenAlertModal}
      />
    </>
  );
}
